type ApiErrorBody = { error?: unknown; reason?: unknown };
type MaybeApiError = { response?: { status?: number; data?: ApiErrorBody } };

/** HTTP status of a failed API call, if the server answered. */
export function apiErrorStatus(err: unknown): number | undefined {
  return (err as MaybeApiError | null)?.response?.status;
}

/**
 * The server's own explanation of a failed API call, or `fallback` when it gave none.
 * Refusals carry `reason` (role ladder, missing permission); other errors carry `error`.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const data = (err as MaybeApiError | null)?.response?.data;
  if (typeof data?.reason === 'string' && data.reason) return data.reason;
  if (typeof data?.error === 'string' && data.error) return data.error;
  return fallback;
}
